class LogController {

	log(...content) {
		console.log(...content); // eslint-disable-line no-console
	}

	warn(...content) {
		console.warn(...content); // eslint-disable-line no-console
	}

	error(...content) {
		console.error(...content); // eslint-disable-line no-console
	}

}

export default new LogController();
